// plutusChatApi.js — saved Plutus chats, shared by the Plutus page
// (AIChatTab.jsx) and the assistant dock (assistant/AssistantDock.jsx). The server
// keeps the history (backend ai_routes.py: ai_conversations /
// ai_chat_messages), so both surfaces show the same conversations and nothing
// is lost on refresh. After a send, a window event tells the other surface to
// refresh.

const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:5000';
const authHeaders = () => ({ Authorization: `Bearer ${localStorage.getItem('token')}` });

export const PLUTUS_CHAT_EVENT = 'plutus:conversation-updated';

export function listConversations() {
  return fetch(`${API_BASE}/api/ai/conversations`, { headers: authHeaders() })
    .then((r) => (r.ok ? r.json() : { conversations: [] }))
    .then((d) => d.conversations || [])
    .catch(() => []);
}

export function getConversation(id) {
  return fetch(`${API_BASE}/api/ai/conversations/${id}`, { headers: authHeaders() })
    .then((r) => (r.ok ? r.json() : null))
    .catch(() => null);
}

// Resolves to the server payload: {reply, conversation_id, title, used, cap}
// or {error, cap_reached}. Never rejects.
export function sendChatMessage({ conversationId, message, source }) {
  return fetch(`${API_BASE}/api/ai/chat`, {
    method: 'POST',
    headers: { ...authHeaders(), 'Content-Type': 'application/json' },
    body: JSON.stringify({ message, ...(conversationId ? { conversation_id: conversationId } : null) }),
  })
    .then((r) => r.json())
    .then((d) => {
      if (d.conversation_id) {
        window.dispatchEvent(new CustomEvent(PLUTUS_CHAT_EVENT, { detail: { conversationId: d.conversation_id, source } }));
      }
      return d;
    })
    .catch(() => ({ error: 'Connection error — try again.' }));
}

// "Today 3:04 PM" / "Sep 12" for the chat list.
export function chatTimeLabel(iso) {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  const now = new Date();
  return d.toDateString() === now.toDateString()
    ? d.toLocaleTimeString('default', { hour: 'numeric', minute: '2-digit' })
    : d.toLocaleDateString('default', { month: 'short', day: 'numeric' });
}
